import { Action, ActionType, SmsPreviewState } from './types';

export const initialState: SmsPreviewState = {
  smsCustomization: [{ locale: 'en', templates: [] }],
  fetching: true,
  submitting: false,
  isPreview: false,
  submitError: false
};

export const smsPreviewReducer = (state: SmsPreviewState, action: Action): SmsPreviewState => {
  switch (action.type) {
    case ActionType.getSmsSuccess:
      return {
        ...state,
        fetching: false,
        smsCustomization: action.payload
      };
    case ActionType.getSmsFail:
      return { ...state, fetching: false };
    case ActionType.updateSms:
      return {
        ...state,
        smsCustomization: action.payload || state.smsCustomization
      };
    case ActionType.submitStarted:
      return { ...state, submitting: true, submitError: false };
    case ActionType.submitSuccess:
      return {
        ...state,
        submitting: false,
        smsCustomization: action.payload
      };
    case ActionType.submitFailed:
      return { ...state, submitting: false, submitError: true };
    default:
      throw new Error('Unknown action type in Sms preview reducer!');
  }
};
